// libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// types
import { Reducers } from 'store/types'
import { ISystemProcessRelatedForm } from 'types/graphql'
// utils
import uniqBy from 'lodash/uniqBy'

export type RelatedFormsState = Record<string, any[]>

const initialState: RelatedFormsState = {}

export const relatedFormsSlice = createSlice({
  name: Reducers.RELATED_FORMS,
  initialState,
  reducers: (create) => ({
    addRelatedForm: create.reducer(
      (
        state,
        action: PayloadAction<{
          id: string
          form: ISystemProcessRelatedForm
        }>
      ) => {
        state[action.payload.id] = Array.isArray(state[action.payload.id])
          ? uniqBy([...state[action.payload.id], action.payload.form], 'riskTemplateId')
          : [action.payload.form]
      }
    ),
    updateRelatedForm: create.reducer(
      (
        state,
        action: PayloadAction<{
          id: string
          form: ISystemProcessRelatedForm
        }>
      ) => {
        state[action.payload.id] = Array.isArray(state[action.payload.id])
          ? state[action.payload.id].map((item) => {
              if (item.riskTemplateId === action.payload.form.riskTemplateId) {
                return action.payload.form
              }

              return item
            })
          : [action.payload.form]
      }
    ),
    removeRelatedForm: create.reducer(
      (
        state,
        action: PayloadAction<{
          id: string
          riskId: string
        }>
      ) => {
        state[action.payload.riskId] = state[action.payload.riskId].filter(
          ({ riskTemplateId }) => riskTemplateId !== action.payload.id
        )
      }
    )
  }),
  selectors: {
    relatedFormById: (state, id: string) => state[id]
  }
})

export const { addRelatedForm, removeRelatedForm, updateRelatedForm } = relatedFormsSlice.actions

export const { relatedFormById } = relatedFormsSlice.selectors
